import React from 'react';
import PanelContentHeader from '../PanelContentHeader/PanelContentHeader';
import ArrowBack from '@portal/assets/svg/arrow_back.svg?react';
import { useNavigation } from '@portal/hooks/useNavigation';

interface IProps {
  subtitle: string;
}

const Header = (props: IProps) => {
  const navigate = useNavigation();

  return (
    <div className="header-pages__container-left">
      <button type="button" onClick={() => navigate.back()}>
        <ArrowBack />
      </button>

      <PanelContentHeader pageTitle="Internet Banking" />

      <p className="header-pages__container-left__subtitle">{props.subtitle}</p>
      <hr />
    </div>
  );
};

export default Header;
